import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import Styles from "./Header.module.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Image from "../../components/Image/Image";
import images from "../../assets/images/images";
import useResponsive from "../../hooks/useResponsive";
import { FaBars } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { IoMdArrowDropdown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { FaSortDown } from "react-icons/fa";
import { LogoutUser } from "../../redux/slices/auth";
import { CircularProgress } from "@mui/material";
import ChangePasswordForm from "../../sections/main/ChangePasswordForm";
import { updateTab } from "../../redux/slices/app";
import { IoSearchOutline } from "react-icons/io5";

const cx = classNames.bind(Styles);

const EditModal = ({ show, onHide, isLoadingAddUser }) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [show]);

  return (
    <div
      className={cx("modal", show ? "show-modal" : "hidden-modal")}
      onClick={onHide}
    >
      <div
        className={cx("modal-container", show ? "slide-in" : "slide-out")}
        onClick={(e) => e.stopPropagation()}
      >
        <span className={cx("modal-title")}>Edita tu perfil</span>

        <button className={cx("close-btn")} onClick={onHide}>
          <IoClose className={cx("close-icon")} />
        </button>
        <ChangePasswordForm onHide={onHide} />
      </div>
    </div>
  );
};

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isLoggedIn, role } = useSelector((state) => state.auth);

  const isDesktop = useResponsive("up", 960);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [isManualDropdownMobile, setIsManualDropdownMobile] = useState(false);
  const [edit, setEdit] = useState(false);

  const navigate = useNavigate();

  const { tab } = useSelector((state) => state.app);

  useEffect(() => {
    const url = window.location.pathname;
    const lastSlash = url.lastIndexOf("/");
    const newTab = url.slice(lastSlash + 1, url.length);

    if (newTab && tab !== newTab) {
      dispatch(updateTab(newTab));
    }
  }, [location, dispatch, tab]);

  const handleUpdateTab = (tab) => {
    dispatch(updateTab(tab));
    navigate(`/${tab}`);
  };

  const toggleOpenMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };

  const toggleManualDropdownMobile = () => {
    setIsManualDropdownMobile(!isManualDropdownMobile);
  };

  const handleLogout = async () => {
    try {
      await dispatch(LogoutUser());
      setTimeout(() => {
        dispatch(updateTab("home"));
        navigate("/");
        window.location.reload();
      }, 100);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className={cx("wrapper")}>
      {!isDesktop ? (
        <>
          <div className={cx("header-mobile")}>
            <button className={cx("nav-bar-btn")} onClick={toggleOpenMenu}>
              <FaBars className={cx("nav-bar-icon")} />
            </button>
            {isLoggedIn ? (
              <div className={cx("profile")}>
                <span className={cx("profile-content-mobile")}>
                  {role}
                  <FaSortDown className={cx("profile-icon")} />
                </span>
                <ul className={cx("profile-dropdown")}>
                  <li
                    className={cx("profile-item")}
                    onClick={() => setEdit(true)}
                  >
                    Información personal
                  </li>
                  <li className={cx("profile-item")} onClick={handleLogout}>
                    Cerrar sesión
                  </li>
                </ul>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div
            className={cx("overlay", { "overlay-visible": isOpenMenu })}
            onClick={() => setIsOpenMenu(false)}
          ></div>
          <div
            className={cx("sidebar", { "open-menu": isOpenMenu })}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={cx("close-btn")}
              onClick={() => setIsOpenMenu(false)}
            >
              <IoClose className={cx("close-icon")} />
            </button>
            <ul className={cx("sidebar-menu")}>
              <li
                className={cx(
                  "item-mobile",
                  tab === "" ? "active-mobile" : ""
                )}
                onClick={() => {
                  handleUpdateTab("");
                  toggleOpenMenu();
                }}
              >
                Inicio
              </li>
              <li
                className={cx(
                  "item-mobile",
                  tab === "about-us" ? "active-mobile" : ""
                )}
                onClick={() => {
                  handleUpdateTab("about-us");
                  toggleOpenMenu();
                }}
              >
                ¿Quiénes somos?
              </li>
              <li
                className={cx(
                  "item-mobile",
                  tab === "legal-framework" ? "active-mobile" : ""
                )}
                onClick={() => {
                  handleUpdateTab("legal-framework");
                  toggleOpenMenu();
                }}
              >
                Marco legal
              </li>
              <li
                className={cx(
                  "item-mobile",
                  tab === "user-manual" || tab === "infracciones-guide"
                    ? "active-mobile"
                    : "",
                  isManualDropdownMobile ? "dropdown-mobile-active" : ""
                )}
                onClick={toggleManualDropdownMobile}
              >
                Manual del Usuario
                <IoMdArrowDropdown />
                <ul className={cx("dropdown-mobile-content")}>
                  <li
                    className={cx("dropdown-mobile-link")}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUpdateTab("user-manual");
                      setIsManualDropdownMobile(false);
                      toggleOpenMenu();
                    }}
                  >
                    Uso del Sistema
                  </li>
                  <li
                    className={cx("dropdown-mobile-link")}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUpdateTab("infracciones-guide");
                      setIsManualDropdownMobile(false);
                      toggleOpenMenu();
                    }}
                  >
                    Guía de Infracciones
                  </li>
                </ul>
              </li>
              <li
                className={cx(
                  "item-mobile",
                  tab === "resource-center" ? "active-mobile" : ""
                )}
                onClick={() => {
                  handleUpdateTab("resource-center");
                  toggleOpenMenu();
                }}
              >
                Centro de Recursos
              </li>
              <li
                className={cx(
                  "item-mobile",
                  tab === "faq" ? "active-mobile" : ""
                )}
                onClick={() => {
                  handleUpdateTab("faq");
                  toggleOpenMenu();
                }}
              >
                Preguntas Frecuentes
              </li>
            </ul>
          </div>
        </>
      ) : (
        ""
      )}
      <div className={cx("header")}>
        <Link to="/" className={cx("logo-wrapper")}>
          <Image src={images.logo} alt="Logo" className={cx("logo-img")} />
        </Link>
        <div className={cx("header-feature-wrapper")}>
          {isLoggedIn && isDesktop ? (
            <div className={cx("profile")}>
              <span className={cx("profile-content")}>
                {role}
                <FaSortDown className={cx("profile-icon")} />
              </span>
              <ul className={cx("profile-dropdown")}>
                <li
                  className={cx("profile-item")}
                  onClick={() => setEdit(true)}
                >
                  Información personal
                </li>
                <li className={cx("profile-item")} onClick={handleLogout}>
                  Cerrar sesión
                </li>
              </ul>
            </div>
          ) : (
            <></>
          )}
          <div className={cx("right-btns")}>
            {isDesktop ? (
              <Link
                to="/detection"
                className={cx("header-search")}
                onClick={() => handleUpdateTab("detection")}
              >
                <span className={cx("header-search-item")}>
                  <IoSearchOutline className={cx("header-search-icon")} />
                </span>
                Infracciones
              </Link>
            ) : (
              <Link
                to="/detection-mobile"
                className={cx("header-search")}
                onClick={() => handleUpdateTab("detection")}
              >
                <span className={cx("header-search-item")}>
                  <IoSearchOutline className={cx("header-search-icon")} />
                </span>
                Infracciones
              </Link>
            )}
            <Link to="/jot-form" className={cx("header-btn")}>
              <Image
                src={images.headerBtn}
                className={cx("header-btn-img")}
                alt="header button"
              />
            </Link>
          </div>
        </div>
      </div>
      <div className={cx("header-bottom")}></div>

      <EditModal show={edit} onHide={() => setEdit(false)} />
    </div>
  );
};

export default Header;
